module.exports = __webpack_public_path__ + "img/information-icon2.a733b57e.png";